<template>
    <div class="container mx-auto my-10 p-4">
        <div class="w-full place-content-center">
            <div class="w-full p-4 text-center">
                <div class="card-header p-4">
                    <h2 v-if="language=='en'">Place an Order</h2>
                    <h2 v-else>下单</h2>
                </div>

                <div class="flex flex-wrap bg-white rounded-md p-8 my-4">
                    <div class="flex-column">
                        <h5 class="mb-2 text-left" v-if="language == 'en'">Products</h5>
                        <h5 class="mb-2 text-left" v-else>产品</h5>

                        <div v-for="(product, index) in products" :key="index" class="text-left">
                            <div class="w-full h-full bg-contain bg-no-repeat bg-center" :style="{ 'background-image': 'url(' + product.thumbnail + ')', 'width': '75px', 'height': '75px' }"></div>
                            <p>{{product.name}} - ${{product.price}}</p>
                        </div>


                        <h5 class="mb-2 text-left" v-if="language == 'en'">Total Price</h5>
                        <p class="text-left">${{_order.total_price}}</p>
                    </div>
                </div>


                <div class="flex flex-wrap bg-white rounded-md p-4">
                    <TextInput
                        class="w-full"
                        :label="language == 'en' ? 'Your Name - English' : '您的姓名 - English'"
                        name="name"
                        id="name"
                        v-model="checkoutInfo.name"
                    />

                    <p v-if="nameError" class="text-red-500 px-4">
                        Required*
                    </p>

                    <TextInput
                        class="w-full"
                        :label="language == 'en' ? 'Delivery Address' : '配送地址'"
                        name="delivery_address"
                        id="delivery_address"
                        v-model="checkoutInfo.deliveryAddress"
                    />

                    <p v-if="addressError" class="text-red-500 px-4">
                        Required*
                    </p>

                    <Button class="w-full"
                        type="submit"
                        id="checkout-submit"
                        :label="language == 'en' ? 'Submit' : '提交'"
                        @click="sendOrder"
                    />
                </div>
                 <Button
                    class="w-full"
                    :label="language == 'en' ? 'Go to Dashboard' : 'Go to Dashboard'"
                    @click="gotoDashboard"
                />
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

import TextInput from './forms/TextInput'
import FileUpload from './forms/FileUpload'

export default {
    props: ['user', 'order', 'recommendation'],
    components: {
        TextInput,
        FileUpload
    },
    data() {
        return {
            products: null,
            checkoutInfo: {
                'name': null,
                'deliveryAddress': null,
            },
            nameError: false,
            addressError: false,
            anyError: false,
        }
    },
    computed: {
        ...mapGetters({
            language: 'clientLanguage'
        }),
        _user() {
            return JSON.parse(this.user);
        },
        _order() {
            return JSON.parse(this.order);
        },
        _recommendation() {
            return JSON.parse(this.recommendation);
        },
    },
    async created() {
        await this.loadProducts();

        this.checkoutInfo.name = this._user.name;
        this.checkoutInfo.email = this._user.email;
        this.checkoutInfo.deliveryAddress = this._order.address;
        console.log('this._user :>> ', this._user);
    },
    methods: {
        async loadProducts() {
            const response = await axios.post('/checkout/products', {'recommendationID': this._recommendation.id})
            console.log('loadProductResponse :>> ', response);

            if(response.data) {
                this.products = this.sortProducts(response.data);
            }
        },
        async sendOrder() {
            this.resetErrors();

            if(!this.checkoutInfo.name) {
                this.nameError = true;
            }

            if(!this.checkoutInfo.deliveryAddress) {
                this.addressError = true;
            }

            if(this.isError()) {
                return;
            }

            const data = {};
            data['checkoutInfo'] = this.checkoutInfo;
            data['order_id'] = this._order.id;

            const response = await axios.post('/checkout', {'data': data});
            window.location = '/dashboard';

            return;
        },
        // We want to have the most expensive product as first product
        sortProducts(products) {
            const newProductArray = [];

            if(products.length > 1) {
                if(products[0].price < products[1].price) {
                    newProductArray.push(products[1]);
                    newProductArray.push(products[0]);
                }
                else {
                    newProductArray.push(products[0]);
                    newProductArray.push(products[1]);
                }
            }
            else {
                newProductArray.push(products[0]);
            }

            return newProductArray;
        },
        gotoDashboard() {
            window.location.href = `dashboard`;
        },

        resetErrors() {
            this.nameError = false;
            this.addressError = false;
        },
        isError() {
            if(this.nameError) {
                return true;
            }
            if(this.addressError) {
                return true;
            }

            return false;
        }
    }
}
</script>

<style>

</style>
